export default function CuisineFieldset({
  cuisines,
  setCuisines,
  cuisineChoices,
}) {
  const handleToggle = (id) => {
    setCuisines((prev) =>
      prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id],
    );
  };

  return (
    <div className="field">
      <label className="field-label">
        Cuisines I'm Into <span className="required-field">*</span>
      </label>
      <p className="callout">
        Helps us suggest the right events for you, and gives fellow Fudopians a
        taste of what you're into.
      </p>
      <div className="chips">
        {cuisineChoices?.map((cuisine) => (
          <label
            key={cuisine.id}
            className={`chip ${cuisines.includes(cuisine.id) ? "chip--selected" : ""}`}
          >
            <input
              type="checkbox"
              value={cuisine.id}
              checked={cuisines.includes(cuisine.id)}
              onChange={() => handleToggle(cuisine.id)}
              style={{ position: "absolute", opacity: 0, width: 0, height: 0 }}
            />
            {cuisine.title}
          </label>
        ))}
      </div>
    </div>
  );
}
